// Google Analytics 4 (GA4) helper — loads gtag.js dynamically and exposes
// simple tracking helpers. Measurement ID comes from env (REACT_APP_GA_MEASUREMENT_ID).

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
let initialized = false;

export const isGAEnabled = () => Boolean(GA_ID);

export function initGA() {
  if (initialized || !GA_ID) return;
  initialized = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  // Disable automatic page_view so SPA route changes are tracked manually.
  gtag("config", GA_ID, { send_page_view: false });
}

export function trackPageView(path) {
  if (!GA_ID || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function trackEvent(name, params = {}) {
  if (!GA_ID || !window.gtag) return;
  window.gtag("event", name, params);
}

// E-commerce helpers (GA4 recommended events)
export function trackAddToCart(item, quantity = 1) {
  trackEvent("add_to_cart", {
    currency: "INR",
    value: (item.price || 0) * quantity,
    items: [
      {
        item_id: item.id || item.product_id,
        item_name: item.name,
        price: item.price,
        quantity,
      },
    ],
  });
}

export function trackBeginCheckout(items, value) {
  trackEvent("begin_checkout", {
    currency: "INR",
    value,
    items: items.map((i) => ({
      item_id: i.product_id,
      item_name: i.name,
      price: i.price,
      quantity: i.quantity,
    })),
  });
}

export function trackPurchase(order) {
  trackEvent("purchase", {
    transaction_id: order.id,
    currency: "INR",
    value: order.total,
    items: (order.items || []).map((i) => ({
      item_id: i.product_id,
      item_name: i.name,
      price: i.price,
      quantity: i.quantity,
    })),
  });
}
